"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierEan = void 0;
var SupplierEan;
(function (SupplierEan) {
    SupplierEan["ESSENT"] = "8714252007299";
    SupplierEan["ENERGIEDIRECT"] = "8712423010956";
})(SupplierEan = exports.SupplierEan || (exports.SupplierEan = {}));
